import { Typography } from '@mui/material';
import { ConvertMprcColorsToString } from 'components';
import React from 'react';
import { MprcLink } from './MprcLink';

interface IProps {
    children: React.ReactNode;
    onClick?: () => void;
    color?: MprcColors;
    highlighted?: boolean;
    highlightedColor?: MprcColors;
    disabled?: boolean;
}

export const MprcListItemTitle: React.FC<IProps> = ({ children, color, highlighted, highlightedColor = "warning", disabled, onClick }) => {
    return (
        <Typography
            variant="h5"
            noWrap
            sx={{ color: (theme) => color ?? (highlighted ? ConvertMprcColorsToString(theme, highlightedColor) : theme.palette.muted.dark) }}
            component="div"
        >
            {
                onClick ?
                    <MprcLink
                        disabled={disabled}
                        color="inherit"
                        fontSize="inherit"
                        onClick={onClick}
                    >
                        {children}
                    </MprcLink>
                    :
                    <>
                        {children}
                    </>
            }
        </Typography>
    );
};
